import styled from "styled-components";
import { GreenValue, Typography } from "../../../../../components";
import { config } from "../../../../../config";
import { usePoolsInfo } from "./usePoolsInfo";
import { device } from "../../../../../style";
import { verticalDesktopLine, verticalLine } from "../../../../../assets";

const Container = styled.div`
  position: relative;
  display: flex;
  width: calc(100% + 100px);
  gap: 15px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.2);
  margin: 0 -50px;
  padding: 10px 50px;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(to right, #156a4ba6, #462373);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  @media ${device.tablet} {
    width: 100%;
    margin: 0;
    padding: 24px 30px 20px;
  }

  @media ${device.laptop} {
    max-width: 1410px;
    margin: 0 auto;
  }
`;

const InsideWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 10px;

  @media ${device.tablet} {
    padding: 0 20px;
  }
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media ${device.tablet} {
    gap: 6px;
  }
`;

const Line = styled.img`
  height: 44px;
  display: block;
  width: 30%;

  @media ${device.tablet} {
    display: none;
  }
`;

const DesktopLine = styled.img`
  display: none;

  @media ${device.tablet} {
    display: block;
    height: 86px;
    width: 30%;
  }
`;

export const PoolsInfo = () => {
  const { tvl, highestAPY } = usePoolsInfo();

  return (
    <Container>
      <InsideWrapper>
        <InfoBoxWrapper>
          <Typography.IngraLabel>TOTAL APR UP TO</Typography.IngraLabel>
          <GreenValue firstPart={highestAPY} secondPart="%" />
        </InfoBoxWrapper>
        <Line src={verticalLine} alt="vertical line" />
        <DesktopLine src={verticalDesktopLine} alt="vertical line" />
        {/* <InfoBoxWrapper>
          <Typography.IngraLabel>OPEN POOLS</Typography.IngraLabel>
          <GreenValue
            firstPart={openPoolsHardCaps}
            secondPart={openPoolsHardCaps ? config.STABLE_TOKEN : ""}
            isCurrencyValue
          />
        </InfoBoxWrapper> */}
        {/* <Line src={verticalLine} alt="vertical line" /> */}
        {/* <DesktopLine src={verticalDesktopLine} alt="vertical line" /> */}
        <InfoBoxWrapper>
          <Typography.IngraLabel>TOTAL VALUE LOCKED</Typography.IngraLabel>
          <GreenValue
            firstPart={tvl}
            secondPart={tvl ? config.STABLE_TOKEN : ""}
            isCurrencyValue
          />
        </InfoBoxWrapper>
      </InsideWrapper>
    </Container>
  );
};
